import { SOLID_FRAME_BACKGROUND_URL } from '../../../../../assets/deliveryDialogAssets';
import './SolidFrameBackground.css';

/** From Figma solid_frame_background (119:6948) — 108.5 191 865×1346. */
export function SolidFrameBackground() {
  return (
    <img
      className="solid-frame-background"
      src={SOLID_FRAME_BACKGROUND_URL}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
